

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './contents/shared/pages/not-found/not-found.component';
import { LandingComponent } from './contents/shared/pages/landing/landing.component';
import { DomainExpiredComponent } from './contents/shared/pages/domain-expired/domain-expired.component';
import { environment } from 'src/environments/environment';
import { WebTypeConstant } from './shared/constants/common-constant';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => {
            const webType = localStorage.getItem(environment.TokenKeys.WebType);
            if (webType === WebTypeConstant.ADMIN || webType === WebTypeConstant.ADMINSTAFF) {
                return import('./contents/admin/admin.module').then(m => m.AdminModule);
            } else if (webType === WebTypeConstant.MERCHANT || webType === WebTypeConstant.MERCHANTSTAFF) {
                return import('./contents/merchant/merchant.module').then(m => m.MerchantModule);
            } else if (webType === WebTypeConstant.AGENTUNLIMITED || webType === WebTypeConstant.AGENTSTAFFUNLIMITED) {
                return import('./contents/agent/agent.module').then(m => m.AgentModule);
            } else {
                // Return a rejected promise so Angular routing aborts
                return Promise.reject('webType not defined');
            }
        }
    },
    { path: 'not-found', component: NotFoundComponent },
    { path: 'domain-expired', component: DomainExpiredComponent },
    { path: '**', component: NotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {

}

